import { redirect, LoaderFunctionArgs } from "react-router-dom";
import { getEventService } from "services/events.service";
import { EventStatus } from "interfaces";

/**
 * Loader for /join/:presentationId route that validates the event
 * - If the event doesn't exist, throws a 404 response
 * - If the event has ended, redirects to the event details page
 * - Otherwise, allows access to the join page
 */
export async function joinEventGuardLoader({ params }: LoaderFunctionArgs) {
  const eventId = params.presentationId;

  if (!eventId) {
    throw new Response("Event not found", { status: 404 });
  }

  try {
    const event = await getEventService(eventId);

    // If no event data returned, show 404
    if (!event || !event.id) {
      throw new Response("Event not found", { status: 404 });
    }

    // If event has ended, redirect to event details page
    if (event.status === EventStatus.Ended) {
      return redirect(`/event-details/${eventId}`);
    }

    // Event is valid and has not ended, allow access
    return null;
  } catch (error) {
    // If the API call fails (e.g., 404 from server), show 404 page
    if (error instanceof Response) {
      throw error;
    }
    throw new Response("Event not found", { status: 404 });
  }
}
